<div [ngClass]="focusedElement === FocusedElement.CVV ? 'card-item -active' : 'card-item'">
  <div class="card-item__side -front">
    <div
      [ngClass]="focusStyle ? 'card-item__focus -active' : 'card-item__focus'"
      [ngStyle]="focusStyle"
    ></div>
    <div class="card-item__cover">
      <img class="card-item__bg" src="http://cdn.pedix.app/landing/card/bg.jpg" />
    </div>
    <div class="card-item__wrapper">
      <div class="card-item__top">
        <img src="http://cdn.pedix.app/landing/card/chip.png" class="card-item__chip" />
        <div class="card-item__type">
          <img src="http://cdn.pedix.app/landing/card/pedix.png" class="card-item__typeImg" />
        </div>
      </div>
      <label class="card-item__number" #cardNumber>
        @for (cardPlaceHolderLetter of currentCardNumberPlaceholder; track cardPlaceHolderLetter; let i = $index) {
          <span>
            <span
              *pxwIfUndefinedChanges="cardModel.cardNumber.charAt(i)"
              [@slideFadeUp]="'in'"
              class="card-item__numberItem"
              >
              @if (getIsNumberMasked(i)) {
                <ng-container
                  class="card-item__numberItem"
                  >*
                </ng-container>
              } @else {
                @if (cardModel.cardNumber.length > i) {
                  <ng-container
                    class="card-item__numberItem"
                    >
                    {{ cardModel.cardNumber.charAt(i) }}</ng-container
                    >
                  } @else {
                    {{ cardPlaceHolderLetter }}
                  }
                }
              </span>
            </span>
          }
        </label>
        <div class="card-item__content">
          <label class="card-item__info" #cardName>
            <div class="card-item__holder">{{ cardLabels.cardHolder }}</div>
            @if (cardModel?.cardName.length > 0) {
              <div class="card-item__name">
                @for (placeHolder of cardHolderNamePlaceholder; track placeHolder; let i = $index) {
                  <span
                    class="card-item__nameItem"
                    >
                    <span
                      *pxwIfUndefinedChanges="cardModel?.cardName.charAt(i)"
                      [@cardHolderFadeRight]="'in'"
                      >{{ cardModel?.cardName.charAt(i) }}</span
                      >
                    </span>
                  }
                </div>
              } @else {
                <span [@cardHolderFadeUp]="'in'">{{ cardLabels.fullName }}</span>
              }
            </label>
            <div class="card-item__date" #expireDate>
              <label class="card-item__dateTitle">{{ cardLabels.expires }}</label>
              <label
                class="card-item__dateItem"
                *pxwIfEveryChanges="cardModel?.expirationMonth"
                [@slideFadeUp]="'in'"
                >
                @if (cardModel.expirationMonth) {
                  <span>{{
                    cardModel.expirationMonth
                  }}</span>
                } @else {
                  {{ cardLabels.mm }}
                }
              </label>
              /
              <label
                for="cardYear"
                class="card-item__dateItem"
                *pxwIfEveryChanges="cardModel?.expirationYear"
                [@slideFadeUp]="'in'"
                >
                @if (cardModel.expirationYear) {
                  <span>{{
                    cardModel.expirationYear.slice(2, 4)
                  }}</span>
                } @else {
                  {{ cardLabels.yy }}
                }
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="card-item__side -back">
        <div class="card-item__cover">
          <img class="card-item__bg" src="" />
        </div>
        <div class="card-item__band"></div>
        <div class="card-item__cvv">
          <div class="card-item__cvvTitle">CVV</div>
          <div class="card-item__cvvBand">
            @for (n of cardModel?.cvv.split(''); track n) {
              <span>*</span>
            }
          </div>
          <div class="card-item__type">
            <img src="" class="card-item__typeImg" />
          </div>
        </div>
      </div>
    </div>
